import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  MPI_MONTH_MAPPER,
  PRICE_CHANGE_MAPPER,
  SCENARIO_KEYS_MAPPER,
} from 'src/app/shared/shared-config';

@Component({
  selector: 'app-base-scenario-details',
  standalone: false,

  templateUrl: './base-scenario-details.component.html',
  styleUrl: './base-scenario-details.component.scss',
})
export class BaseScenarioDetailsComponent implements OnInit {
  baseDetails: any;
  childDetails: any;
  priceChangesMapper = PRICE_CHANGE_MAPPER;
  scenarioKeysMapper = SCENARIO_KEYS_MAPPER;
  displayKeys = [
    this.scenarioKeysMapper.CATEGORY,
    this.scenarioKeysMapper.PRICE,
    this.scenarioKeysMapper.START_DATE,
    this.scenarioKeysMapper.END_DATE,
  ];
  labelMappers = {
    [this.scenarioKeysMapper.CATEGORY]: 'Category',
    [this.scenarioKeysMapper.END_DATE]: 'End Date',
    [this.scenarioKeysMapper.START_DATE]: 'Start Date',
    [this.scenarioKeysMapper.PRICE]: 'Price Change',
  };
  constructor(private route: ActivatedRoute) {}
  displayData = [];

  ngOnInit(): void {
    console.log(this.scenarioKeysMapper);
    this.route.queryParams.subscribe((params) => {
      this.baseDetails = params?.['baseDetails'];
      if (this.baseDetails) {
        this.baseDetails = JSON.parse(this.baseDetails);
        this.displayData = this.displayKeys.map((key) => {
          let temp = {
            key: this.labelMappers[key],
            value: this.baseDetails[key],
          };
          //3 conditions for start date
          //3 conditions for end date
          if (
            (key === this.scenarioKeysMapper.START_DATE ||
              key === this.scenarioKeysMapper.END_DATE) &&
            this.baseDetails[this.scenarioKeysMapper.PRICE] ===
              PRICE_CHANGE_MAPPER.PCM
          ) {
            temp.value = `${this.baseDetails[key]['year']} - ${this.baseDetails[key]['month']} - ${this.baseDetails[key]['week']}`;
          }

          if (
            (key === this.scenarioKeysMapper.START_DATE ||
              key === this.scenarioKeysMapper.END_DATE) &&
            this.baseDetails[this.scenarioKeysMapper.PRICE] ===
              PRICE_CHANGE_MAPPER.MPI
          ) {
            temp.value = `${this.baseDetails[key]['year']} - ${MPI_MONTH_MAPPER[this.baseDetails[key]['month']]}`;
          }

          if (
            (key === this.scenarioKeysMapper.START_DATE ||
              key === this.scenarioKeysMapper.END_DATE) &&
            this.baseDetails[this.scenarioKeysMapper.PRICE] ===
              PRICE_CHANGE_MAPPER.POST_CODE_PLAN
          ) {
            temp.value = `${this.baseDetails[key]['year']} - ${this.baseDetails[key]['quarter']}`;
          }
          return temp;
        });
      }

      this.childDetails = params?.['childDetails'];
      if (this.childDetails) {
        this.childDetails = JSON.parse(this.childDetails);
      }
    });
  }
}
